import {
	GET_FILES,
	PUT_FILES,
	DELETE_FILES,
	UPDATE_FILES,
	CLEAR_FILES
} from "../ActionTypes"

const initialState = {
	FilesList: [],
	finish: false,
	finishUpdate: false
}

export default (state = initialState, { type, payload }) => {
	let { FilesList } = state
	switch (type) {
		case GET_FILES + "_FULFILLED":
			return {
				...state,
				FilesList: payload,
				finish: false
			}
		case GET_FILES + "_PENDING":
			return { ...state, finish: true }
		case GET_FILES + "_REJECTED":
			return { ...state, finish: false }
		case PUT_FILES + "_FULFILLED":
			return { ...state, finish: false }
		case PUT_FILES + "_PENDING":
			return { ...state, finish: true }
		case PUT_FILES + "_REJECTED":
			return { ...state, finish: false }
		case DELETE_FILES + "_FULFILLED":
			return { ...state, finish: false }
		case DELETE_FILES + "_PENDING":
			return { ...state, finish: true }
		case DELETE_FILES + "_REJECTED":
			return { ...state, finish: false }
		case UPDATE_FILES + "_FULFILLED": {
			FilesList[payload.idx] = payload.fileUpdate
			return { ...state, finishUpdate: false, FilesList }
		}
		case UPDATE_FILES + "_PENDING":
			return { ...state, finishUpdate: true }
		case UPDATE_FILES + "_REJECTED":
			return { ...state, finishUpdate: false }
		case CLEAR_FILES:
			return { ...state, FilesList: [], finish: false }
		default:
			return state
	}
}
